export default __webpack_public_path__ + "static/media/041-parking.2c36baed.png";